<template>
  <a
    target="_blank"
    :href="url"
    :title="value">
    <slot name="value" />
    {{ shortener(value) }}
  </a>
</template>

<script>
import { shortener } from '@/js/helpers/string'
import { explorerUrl } from '@/js/helpers/urls'

export const URL_TYPES = [
  { id: 'address' },
  { id: 'tx' },
]

const URL_TYPES_AS_OBJECT = {}
URL_TYPES.forEach(row => {
  URL_TYPES_AS_OBJECT[row.id] = row.id
})
export {
  URL_TYPES_AS_OBJECT,
}

export default {
  name: 'eth-link',
  components: {},
  props: {
    explorerUrl: {
      type: String,
      default: '',
      // validator (value) {
      //   // The value must match one of these strings
      //   return Object.keys(NETWORKS_AS_OBJECT).includes(value)
      // },
    },
    type: {
      type: String,
      default: '', // type: address|tx
      validator (value) {
        // The value must match one of these strings
        return Object.keys(URL_TYPES_AS_OBJECT).includes(value)
      },
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    url () {
      const result = explorerUrl(this.type, this.value, this.explorerUrl)
      return result
    },
  },
  methods: {
    shortener,
  },
}
</script>

<style scoped>

</style>
